"use client"

import { usePathname } from 'next/navigation'
import Script from 'next/script'

interface AdSenseScriptProps {
  adsenseId?: string
}

export default function AdSenseScript({ adsenseId }: AdSenseScriptProps) {
  const pathname = usePathname()

  if (!adsenseId) return null

  // 🏛️ SECURITY EXCLUSION:
  // We explicitly prevent the AdSense engine from loading on the digital-edition route.
  // This protects the account from being flagged due to sensitive research reports.
  if (pathname?.startsWith('/digital-edition')) {
    return null
  }

  return (
    <Script
      async
      src={`https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${adsenseId.startsWith('ca-') ? adsenseId : `ca-${adsenseId}`}`}
      crossOrigin="anonymous"
      strategy="beforeInteractive"
    />
  )
}
